import { laptopMediumMax, mobileXLargeMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { Container as ButtonContainer } from '../buttons/Button.style';
import { MAX_WIDTH } from '../layout/PageWrapper.style';

const laptopMediumMin = laptopMediumMax.replace('max', 'min').replace('980', '981');

export const Container = styled.section`
  margin: 40px auto;
  width: 100%;
  max-width: ${MAX_WIDTH}px;
  padding: 0 30px;

  @media (${laptopMediumMax}) {
    padding: 0;
  }
`;

export const Form = styled.form`
  border: solid ${({ theme }) => `9px ${theme.backgroundLightest}`};
  background-color: ${({ theme }) => theme.white};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.textDark};
    margin: 5px 0;
  }

  @media (${tabletMax}) {
    flex-direction: column;
    gap: 30px;
  }
`;

export const Logo = styled.img`
  max-width: 335px;
  max-height: 120px;
  margin-left: 10px;

  @media screen and (${laptopMediumMax}) {
    max-width: 45%;
    order: 2;
  }
`;

export const Title = styled.h2<{ color: string; hasLogo?: boolean; formTitle?: boolean }>`
  color: ${({ color }) => color};
  font-size: 30px;
  font-weight: bold;
  text-align: center;

  @media screen and (${mobileXLargeMax}) {
    font-size: 24px;
  }
`;

export const FormBox = styled.div<{ backgroundColor: string }>`
  padding: 30px;
  background-color: ${(props) => props.backgroundColor};

  @media screen and (${laptopMediumMax}) {
    padding: 30px 15px;
  }
`;

export const FormWrapper = styled.div`
  margin: 30px 0 30px;
  display: flex;

  @media screen and (${laptopMediumMax}) {
    flex-direction: column;
  }
`;

export const FieldContainer = styled.div<{ fullWidth?: boolean }>`
  display: flex;
  flex: 1;

  @media screen and (${laptopMediumMax}) {
    margin-right: -15px;
  }

  ${ButtonContainer} {
    max-width: 300px;
    height: 54px;
    min-height: 54px;
    margin-top: 48px;

    @media screen and (${laptopMediumMax}) {
      max-width: none;
      margin-top: 30px;
      margin-right: 15px;
      width: auto;
    }
  }
`;

export const MortgagePaymentContainer = styled.div`
  display: flex;
  flex-basis: 250px;
  flex-direction: column;

  @media screen and (${laptopMediumMax}) {
    flex-basis: 100%;
    margin-top: 15px;
  }
`;

export const MortgagePayment = styled.div`
  text-align: center;

  & > div {
    justify-content: center;
  }

  @media screen and (${laptopMediumMin}) {
    margin-left: 15px;
  }
`;

export const ErrorText = styled.p`
  color: ${({ theme }) => theme.primary};
  margin: 30px auto;
  max-width: 88%;
  font-weight: 600;
  text-align: center;
`;
